import { createSelector } from '@reduxjs/toolkit';

export const selectDebug = createSelector((store: any) => store, store => store.debug);
